<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.payments">
  <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
    [businesses]="localService.loggedMember.businesses"></app-business-deductive>
  <div class="banner center">
    <div class="row freeze_height">
      <div class="col-md-8">
        <div class="row">
          <div class="col-sm-12">
            <div *ngIf="paymentStage == 1">
              <button type="button" class="btn btn-primary" style="margin:5px;"
                (click)="onClick(1)">{{localService.languageContent.payments.pay}}</button>
              <button type="button" class="btn btn-primary" style="margin:5px;" (click)="onClick(4)"
                *ngIf="interactionType != 4">{{localService.languageContent.payments.pay_from_wallet}}</button>
              <button type="button" class="btn btn-primary" style="margin:5px;" (click)="onClick(2)"
                *ngIf="interactionType == 4">{{localService.languageContent.payments.paid}}</button>
              <button type="button" class="btn btn-primary" style="margin:5px;" (click)="onClick(3)"
                *ngIf="interactionType == 4">{{localService.languageContent.payments.waive}}</button>
              <button type="button" class="button_icon button_icon_color "
                style="float: right; font-size: 2em !important; margin-top: -5px !important;" (click)="onGenerateRent()"
                *ngIf="interactionType == 4"
                title="{{localService.languageContent.common.generate_rent}}">play_arrow</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <ngx-select [(ngModel)]="paymentStage" [noAutoComplete]="true" [items]="recordTypes" [optionValueField]="'key'"
          [optionTextField]="'value'" (select)="onLoad()">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <div>
              {{option.data.key == 1 ? localService.languageContent.payments.show_pending_payments : (option.data.key ==
              2 ? localService.languageContent.payments.show_paid_payments :
              localService.languageContent.payments.show_waived_payments)}}
            </div>
          </ng-template>
        </ngx-select>
      </div>
    </div>
    <div class="row row_header freeze_height">
      <div class="col-md-6">
        <div class="row">
          <div class="col-2">
            {{localService.languageContent.payments.action}}
          </div>
          <div class="col-10">
            {{localService.languageContent.payments.bill_range}}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-2">
            {{localService.languageContent.payments.amount}}
          </div>
          <div class="col-5">
            {{ paymentStage == 1 ? localService.languageContent.payments.business_name : (paymentStage == 2 ?
            localService.languageContent.payments.paid_by: localService.languageContent.payments.waive_by) }}
          </div>
          <div class="col-5">
            {{ paymentStage == 1 ? localService.languageContent.payments.suspension_on : (paymentStage == 2 ?
            localService.languageContent.payments.paid_on : localService.languageContent.payments.waive_date) }}
          </div>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of wrapper.items">
        <div class="col-md-6">
          <div class="row">
            <div class="col-2">
              <i class="material-icons button icon_adjust" (click)="onOpenInvoice(item.key,1)">receipt</i>
              <i class="material-icons button icon_adjust" (click)="onOpenInvoice(item.key,2)">print</i>
              <i class="material-icons button icon_adjust"
                (click)="localService.showMessage(item.v11,localService.languageContent.common.notes)"
                *ngIf="item.v11">sticky_note_2</i>
            </div>
            <div class="col-10 en">
              <label style="font-weight: normal; margin-left: 10px;" *ngIf="paymentStage == 1">
                <input type="checkbox" [(ngModel)]="item.isSelected" />
                <span>{{ item.v2 | localDate }} - {{ item.v3 | localDate }}</span>
              </label>
              <span *ngIf="paymentStage != 1">{{ item.v2 | localDate }} - {{ item.v3 | localDate }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-2 en" style="text-align:right;">
              {{item.v4 | number: '1.2-2'}}
            </div>
            <div class="col-5">
              <span
                *ngIf="interactionType != 4 && paymentStage != 1 && item.v8 == 'NA'">{{localService.languageContent.payments.auto_debit}}</span>
              <span *ngIf="interactionType == 4 && paymentStage != 1 && item.v8 == 'NA'" class="button"
                title="{{localService.languageContent.payments.auto_debit}}"
                [ngClass]="localService.getLanguageCode(item.v10)"
                (click)="localService.showSummary(item.v12, item.v14 == '1' ? 1 : (item.v6 == '1' ? 2 : 4))">{{item.v1}}</span>
              <span class="button" *ngIf="paymentStage == 1 || (paymentStage != 1 && item.v8 != 'NA')"
                [ngClass]="localService.getLanguageCode(item.v10)"
                (click)="localService.showSummary(item.v12, item.v7 != '1' ? (item.v6 == '2' ? 2 : 4) : 1)">{{
                paymentStage == 1 ? item.v1 : item.v8 }}</span>
            </div>
            <div class="col-5 en">
              {{ (paymentStage == 1 ? item.v5 : item.v9) | localDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="wrapper" [paging]="wrapper.paging" [IsShowDateRange]="true"
    (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<app-print *ngIf="IsPrint" [fileName]="fileName" [content]="printContent" (onPrinted)="onPrinted()">
</app-print>
<app-payments [(isShowPayment)]="isShowPayment" [ids]="ids" [amount]="amountToRecharge" [paidType]="2"
  [businessOrUserId]="businessId && interactionType != 4 ? businessId : userId"
  (onPaymentProccesed)="onPaymentProccesed($event)" [interactionType]="interactionType" />